import { TreeSelectProps } from 'antd';

export const handleClickSelectAll = (
  allKeys: string[],
  value?: string[],
  onChange?: (value: string[]) => void,
) => () => {
  if (value?.length === allKeys.length) {
    return onChange?.([]);
  }

  return onChange?.(allKeys);
};

export const getAllKeys = (treeData: TreeSelectProps['treeData'] = []) => {
  const stack = [...treeData];
  const result: string[] = [];

  while (stack.length > 0) {
    const node = stack.pop();

    if (node?.children) {
      stack.push(...node.children);
    } else if (node?.value) {
      result.push(String(node.value));
    }
  }

  return result;
};
